/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorCodesModel,
  PayPayPaymentRequestModel,
  PostPaypayPayment200Response,
} from '../models/index';
import {
    ErrorCodesModelFromJSON,
    ErrorCodesModelToJSON,
    PayPayPaymentRequestModelFromJSON,
    PayPayPaymentRequestModelToJSON,
    PostPaypayPayment200ResponseFromJSON,
    PostPaypayPayment200ResponseToJSON,
} from '../models/index';

export interface PostPaypayPaymentRequest {
    payPayPaymentRequestModel: PayPayPaymentRequestModel;
    xComiciUserToken?: string;
}

/**
 * 
 */
export class PaymentPayPayApi extends runtime.BaseAPI {

    /**
     * PayPay決済を開始します。レスポンスとしてPayPay決済ページへのURLを返却します。 
     * PayPay決済
     */
    async postPaypayPaymentRaw(requestParameters: PostPaypayPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostPaypayPayment200Response>> {
        if (requestParameters.payPayPaymentRequestModel === null || requestParameters.payPayPaymentRequestModel === undefined) {
            throw new runtime.RequiredError('payPayPaymentRequestModel','Required parameter requestParameters.payPayPaymentRequestModel was null or undefined when calling postPaypayPayment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xComiciUserToken !== undefined && requestParameters.xComiciUserToken !== null) {
            headerParameters['X-Comici-User-Token'] = String(requestParameters.xComiciUserToken);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/payment/paypay/paypayPayment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PayPayPaymentRequestModelToJSON(requestParameters.payPayPaymentRequestModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostPaypayPayment200ResponseFromJSON(jsonValue));
    }

    /**
     * PayPay決済を開始します。レスポンスとしてPayPay決済ページへのURLを返却します。 
     * PayPay決済
     */
    async postPaypayPayment(requestParameters: PostPaypayPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostPaypayPayment200Response> {
        const response = await this.postPaypayPaymentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
